// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DisconnectOutlinedSvg from "@ant-design/icons-svg/es/asn/DisconnectOutlined";
import AntdIcon from '../components/AntdIcon';

var DisconnectOutlined = function DisconnectOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DisconnectOutlinedSvg
  }));
};

DisconnectOutlined.displayName = 'DisconnectOutlined';
export default React.forwardRef(DisconnectOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DisconnectOutlined.js
// module id = 947
// module chunks = 0